import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    this._onClickOutside = this._onClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.dropdownTarget.classList.contains("show")) {
      this._close()
    } else {
      this._open()
    }
  }

  _open() {
    this.dropdownTarget.classList.add("show")
    requestAnimationFrame(() => {
      document.addEventListener("click", this._onClickOutside)
    })
  }

  _close() {
    this.dropdownTarget.classList.remove("show")
    document.removeEventListener("click", this._onClickOutside)
  }

  _onClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this._close()
    }
  }
}
